import { createSlice } from "@reduxjs/toolkit";

export const schoolSlice = createSlice({
  name: "setUpSchool",
  initialState: {
    currentSchool: null,
    currentStream: null,
    currentCourse: null,
    currentChapter: null,
  },
  reducers: {
    onCurrentSchool: (state, action) => {
      state.currentSchool = action.payload;
    },
    onCurrentStream: (state, action) => {
      state.currentStream = action.payload;
    },
    onCurrentCourse: (state, action) => {
      state.currentCourse = action.payload;
    },
    onCurrentChapter: (state, action) => {
      state.currentChapter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("SYNC/schoolStoreState", (state, action) => {
      return action.payload;
    });
  },
});
